import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

@Component({
	selector: 'app-config',
	templateUrl: './config.component.html',
	styleUrls: ['./config.component.css']
})
export class ConfigComponent implements OnInit {

	admPageObj:any = "curr";
	logi_user:any;

	cfgData:any = [];

	frm : FormGroup;

	constructor(
		private http: HttpClient,
		private fb: FormBuilder,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = fb.group({
			priceopen: [''],
		});
	}

	ngOnInit() {
		this.getConfigData();
	}

	async getConfigData() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		this.http.post(this.env.API_URL + 'api/admin.config.php', formData).subscribe((response) => {
			this.cfgData = response['data'];
		});
	}

	async modifyForm(form) {
		this.func.prcLoading();

		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("approval", this.frm.get('approval').value);
		formData.append("mbname", this.frm.get('mbname').value);
		formData.append("mbphone", this.frm.get('mbphone').value);
		formData.append("mbbirth", this.frm.get('mbbirth').value);
		formData.append("mbaddr", this.frm.get('mbaddr').value);
		formData.append("mbemail", this.frm.get('mbemail').value);
		formData.append("mbpwd", this.frm.get('mbpwd').value);
		formData.append("mblicense", this.frm.get('mblicense').value);
		formData.append("approval_p1", this.frm.get('approval_p1').value);
		formData.append("approval_p2", this.frm.get('approval_p2').value);
		formData.append("dfile1", this.frm.get('userfile1').value);
		formData.append("dfile2", this.frm.get('userfile2').value);
		formData.append("dfile5", this.frm.get('userfile3').value);
		formData.append("mbbank", this.frm.get('mbbank').value);
		formData.append("mbeaccount", this.frm.get('mbeaccount').value);
		formData.append("mbeaccountname", this.frm.get('mbeaccountname').value);
		formData.append("mbeaccountreason", this.frm.get('mbeaccountreason').value);
		formData.append("approval_p3", this.frm.get('approval_p3').value);
		formData.append("mbadminmemo", this.frm.get('mbadminmemo').value);

		this.http.post(this.env.API_URL + 'manager/driver.process.php', formData).subscribe((response) => {
			this.func.closeLoading();

			if( response['code'] == 1000 )
			{
				this.func.bottomToast("수정완료");
			}
			else if( response['code'] == 8000 )
			{
				this.func.bottomToast("잘못된 접근입니다.");
			}
			else if( response['code'] == 9000 )
			{
				this.func.bottomToast("저장에 실패하였습니다.");
			}
		});
	}

	photoRun(part, event) {
		let reader = new FileReader();
		const file = event.target.files[0];
		console.log(file);
		this.frm.get(part).setValue(file);
	}

	readFile(file: any) {
		const reader = new FileReader();
		reader.onloadend = () => {
			const imgBlob = new Blob([reader.result], {
				type: "image/jpg"
			});
		};
		reader.readAsArrayBuffer(file);
	}
}
